import { noop } from 'lodash';
import {
  formatCaseData,
  formatClientData,
  formatReferralData,
} from 'src/components/Search/utils';
import { MEDICAID_ID_LABEL, MODELS } from 'src/components/Search/constants';

const { contact, referral, servicecase } = MODELS;

const defaultHeaders = [
  { label: 'Name - Service Type', value: 'name_service_type' },
  { label: 'Created', value: 'created_at' },
  { label: 'Status', value: 'status' },
];

function getSearchBarColumnHeaders(model) {
  switch (model) {
    case contact: {
      const headers = [
        { label: 'Name', value: 'full_name', ariaLabel: 'name' },
        { label: MEDICAID_ID_LABEL, value: 'external_id', ariaLabel: MEDICAID_ID_LABEL },
        { label: 'Phone', value: 'phone', ariaLabel: 'phone' },
        { label: 'DOB', value: 'dob', ariaLabel: 'date of birth' },
        { label: 'Location', value: 'location', ariaLabel: 'location' },
      ];

      return {
        getRowValues: formatClientData,
        headers,
      };
    }
    case referral: {
      return {
        getRowValues: formatReferralData,
        headers: defaultHeaders,
      };
    }
    case servicecase: {
      return {
        getRowValues: formatCaseData,
        headers: defaultHeaders,
      };
    }
    default: {
      return {
        getRowValues: noop,
        headers: [],
      };
    }
  }
}

export default getSearchBarColumnHeaders;
